module.exports = __webpack_public_path__ + "img/millfields_rd_b7.044eec07.jpg";